import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // 1. Firebase Auth ലോഗിൻ
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. Firestore-ൽ നിന്ന് adminUsers വിവരങ്ങൾ എടുക്കുക
      const userDocRef = doc(db, 'adminUsers', user.uid);
      const userDocSnap = await getDoc(userDocRef);

      let userRole = 'super_admin'; // Default fallback
      let userName = 'Admin';

      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        
        // യൂസർ ഇൻആക്റ്റീവ് ആണെങ്കിൽ പ്രവേശനം തടയുക
        if (userData.status === 'Inactive') {
          setError("Your account has been deactivated. Please contact Super Admin.");
          setLoading(false);
          return;
        }

        userRole = userData.role || 'sub_admin';
        userName = userData.name || 'Admin';
      }

      // 3. LocalStorage-ൽ വിവരം സൂക്ഷിക്കുക
      localStorage.setItem('adminUser', JSON.stringify({
        uid: user.uid,
        email: user.email,
        name: userName,
        role: userRole
      }));

      // 4. ഡാഷ്‌ബോർഡിലേക്ക് റീഡയറക്റ്റ് ചെയ്യുക
      navigate('/admin/dashboard'); 
    } catch (err) {
      console.error("Login error: ", err);
      setError("Invalid Email or Password!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>MR WHITE <span>Admin</span></h2>
        {error && <p className="error-msg">{error}</p>}
        
        <input 
          type="email" 
          placeholder="Admin Email" 
          value={email}
          onChange={(e) => setEmail(e.target.value)} 
          required 
        />
        
        <input 
          type="password" 
          placeholder="Password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)} 
          required 
        />
        
        <button type="submit" disabled={loading}>
          {loading ? "Authenticating..." : "Login to Dashboard"}
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;